/* eslint-disable complexity */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useCallback, useMemo, useRef } from 'react';
import { Button, Input, Switch, message, Tooltip } from 'antd';
import classNames from 'classnames';
import pick from 'lodash/pick';
import isError from 'lodash/isError';
import isNull from 'lodash/isNull';
import isFunction from 'lodash/isFunction';
import { getIsSelf, Line, tagsNode } from './common';
import Avatar from '../Avatar';
import UserInfoItem from './UserInfoItem';
import UserDeptTitle from './UserDeptTitle';
import debounce from 'lodash/debounce';
import { getHeadImgThumbUrl } from '../utils';
import IconFont from '../IconFont';
import { UserCardAction, UserCardType, } from './UserCardType';
import colors from '../style/less/colors';
import Infobg from '../images/Infobg.png';
import closeIcon from '../images/Close.png';
import Remark from './Remark';
import TagNode from './Tag';
var TextArea = Input.TextArea;
function UserCard(props) {
    var _this = this;
    var data = props.data, onGetUserLevel = props.onGetUserLevel, openUserLevelDetail = props.openUserLevelDetail, onGetUserInfo = props.onGetUserInfo, onActionClick = props.onActionClick, onSetTagForEmpl = props.onSetTagForEmpl, onGetTagList = props.onGetTagList, onSetTag = props.onSetTag, notPersonalCalendar = props.notPersonalCalendar, isfriend = props.isfriend, currentEmployee = props.currentEmployee, onClickAvatar = props.onClickAvatar, isMessageModule = props.isMessageModule, contactRelationship = props.contactRelationship, friendErrMsg = props.friendErrMsg, triggerEvent = props.triggerEvent, appliesNewContacts = props.appliesNewContacts, hideUserCardModal = props.hideUserCardModal, setModifyFriend = props.setModifyFriend, setEmplFollow = props.setEmplFollow, analysisLog = props.analysisLog, examineMobileRecord = props.examineMobileRecord, webExamineMobileRecord = props.webExamineMobileRecord, remarkSet = props.remarkSet, buttons = props.buttons, isExternsContactsVideo = props.isExternsContactsVideo, isExternsContacts = props.isExternsContacts, canAddContact = props.canAddContact, webUserCardInfo = props.webUserCardInfo;
    // const { isOnlyScanAdd, friendship } = contactRelationship;
    var actions;
    var applyInfos;
    var cardType;
    var group;
    var flag;
    var reply;
    var applyId;
    var isCanReply;
    if (data) {
        actions = data.actions;
        applyInfos = data.applyInfos;
        cardType = data.type;
        group = data.group;
        flag = data.flag;
        reply = data.reply;
        applyId = data.applyId;
        isCanReply = data.isCanReply;
    }
    var _a = React.useState(null), user = _a[0], setUser = _a[1];
    var _b = React.useState(''), error = _b[0], setError = _b[1];
    // 验证消息记数
    var _c = React.useState(0), count = _c[0], setCount = _c[1];
    // 加好友时的验证消息
    var _d = React.useState(''), validationMsg = _d[0], setValidationMsg = _d[1];
    var _e = React.useState(''), remark = _e[0], setRemark = _e[1];
    var _f = React.useState(''), defaultRemark = _f[0], setDefaultRemark = _f[1];
    // 回复好友申请计数
    var _g = React.useState(0), replyCount = _g[0], setReplyCount = _g[1];
    // 回复好友申请验证消息
    var _h = React.useState(''), replyMsg = _h[0], setReplyMsg = _h[1];
    // 操作状态
    var _j = React.useState(null), actionState = _j[0], setActionState = _j[1];
    var prevActionState = useRef(actionState);
    var _k = React.useState(null), workStatus = _k[0], setWorkStatus = _k[1];
    // 验证信息
    var _l = React.useState([]), loadApplyInfos = _l[0], setLoadApplyInfos = _l[1];
    var preAction = useRef(null);
    var _m = React.useState(false), replyIsShow = _m[0], setReplyIsShow = _m[1];
    var _o = React.useState(false), checkedIphone = _o[0], setCheckedIphone = _o[1];
    var _p = React.useState(false), emplFollow = _p[0], setEmplFollowState = _p[1];
    var _q = React.useState(false), emplFollowLoading = _q[0], setEmplFollowLoading = _q[1];
    var _r = React.useState(false), switchLoading = _r[0], setSwitchLoading = _r[1];
    var _s = React.useState(null), userLevelData = _s[0], setUserLevelData = _s[1];
    var defaultValidationMsg = '';
    var isRobot = useMemo(function () { var _a; return (_a = data.userId) === null || _a === void 0 ? void 0 : _a.startsWith("robot_"); }, [data]);
    var handleAddTag = useCallback(function () {
        preAction.current = actionState;
        analysisLog === null || analysisLog === void 0 ? void 0 : analysisLog('xtbg_address_home_1722323222167', '10');
        setActionState(UserCardAction.Tag);
    }, [actionState, analysisLog]);
    var onSaveUserTag = useCallback(function (user, tagIds, tagList) { return __awaiter(_this, void 0, void 0, function () {
        var _a, res, err;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, onSetTagForEmpl({
                        targetAppId: user.appId,
                        targetUserId: user.userId,
                        targetTeamId: user.teamId,
                        tagIds: tagIds,
                    })];
                case 1:
                    _a = _b.sent(), res = _a[0], err = _a[1];
                    if (err) {
                        message.error(err);
                        return [2 /*return*/];
                    }
                    setUser(function (prev) { return (__assign(__assign({}, prev), { tagInfoList: tagList })); });
                    setActionState(preAction.current);
                    return [2 /*return*/];
            }
        });
    }); }, [onSetTagForEmpl]);
    var resetPrevAction = useCallback(function () {
        setActionState(preAction.current);
    }, []);
    var handleRemarkSet = useCallback(function (user, inputVal) {
        if (inputVal === void 0) { inputVal = ''; }
        var remarkMsg = (inputVal === null || inputVal === void 0 ? void 0 : inputVal.trim()) || '';
        setRemark(remarkMsg);
        setUser(__assign(__assign({}, user), { remark: remarkMsg }));
        remarkSet(user, remarkMsg);
    }, [remarkSet]);
    React.useEffect(function () {
        if (friendErrMsg) {
            setError(friendErrMsg);
            return;
        }
        if (actions === null || actions === void 0 ? void 0 : actions.includes(UserCardAction.Chat)) {
            setActionState(UserCardAction.Chat);
            return;
        }
        if (actions === null || actions === void 0 ? void 0 : actions[0]) {
            setActionState(actions[0]);
            return;
        }
        if (isfriend === 1) {
            setActionState(UserCardAction.Chat);
        }
        else {
            setActionState(UserCardAction.Add);
        }
    }, [actions, group, friendErrMsg, isfriend, cardType]);
    React.useEffect(function () {
        if (webUserCardInfo) {
            setUser(__assign(__assign({}, webUserCardInfo), { fields: webUserCardInfo.fields.map(function (item) {
                    return pick(item, ['val', 'hide', 'index', 'key', 'name']);
                }), userId: data.userId, teamId: data.teamId }));
            setEmplFollowState(webUserCardInfo.isFollow ? true : false);
            setRemark(webUserCardInfo.remark || '');
            setDefaultRemark(webUserCardInfo.remark || '');
        }
    }, [data, webUserCardInfo]);
    // 获取并设置用户信息
    React.useEffect(function () {
        var _a = data || {}, userId = _a.userId, teamId = _a.teamId, type = _a.type;
        if (type === UserCardType.Group || type === UserCardType.Web) {
            return;
        }
        if (isfriend === -1) {
            return;
        }
        if (!userId || !teamId) {
            // setError(`invalid userId(${userId}) or teamId(${teamId})`);
            return;
        }
        if (onGetUserLevel) {
            var param = pick(data, ['appId', 'teamId', 'userId']);
            onGetUserLevel(param)
                .then(function (data) {
                setUserLevelData(data);
            })
                .catch(function (e) {
                setError((e === null || e === void 0 ? void 0 : e.message) || '');
            });
        }
        if (onGetUserInfo) {
            var param = pick(data, ['appId', 'teamId', 'userId', 'rootOrgId', 'deptId']);
            onGetUserInfo(param)
                .then(function (data) {
                var _a = data || {}, fields = _a.fields, workStatus = _a.workStatus, accessPhone = _a.accessPhone;
                if (!Array.isArray(fields)) {
                    throw new Error('用户信息获取失败');
                }
                try {
                    if (data.workStatus) {
                        var workStatus_1 = JSON.parse(data.workStatus || '');
                        if (workStatus_1) {
                            setWorkStatus(workStatus_1);
                        }
                    }
                    // setUserLabel(currentUserLabelInfoList);
                }
                catch (error) {
                    console.error(error);
                }
                delete data['workStatus'];
                setUser(__assign(__assign({}, data), { fields: fields.map(function (item) {
                        return pick(item, ['val', 'hide', 'index', 'key', 'name']);
                    }) }));
                setEmplFollowState(data.isFollow ? true : false);
                setRemark(data.remark || '');
                setDefaultRemark(data.remark || '');
                setError('');
            })
                .catch(function (e) {
                setError((e === null || e === void 0 ? void 0 : e.message) || '');
            });
        }
    }, [isfriend]); //eslint-disable-line
    React.useEffect(function () {
        if (![UserCardAction.Accept, UserCardAction.Sended].includes(actionState) ||
            !user ||
            cardType === UserCardType.Web ||
            !appliesNewContacts) {
            setLoadApplyInfos(applyInfos);
            return;
        }
        // 接受好友申请时 获取本地数据口的多条验证信息 （接口只返回一条数据，本地数据缓存了多条一个好友请求3次的数据）
        appliesNewContacts({ app: user.appId, pin: user.userId, teamId: user.teamId })
            .then(function (res) {
            if (res.length > 0) {
                var infos = res === null || res === void 0 ? void 0 : res[0].items;
                var items = infos.sort(function (a, b) {
                    return a.applyTime - b.applyTime;
                });
                if (items.length) {
                    setLoadApplyInfos(items.slice(-3));
                }
            }
        })
            .catch(function (err) {
            console.error(err);
        });
    }, [actionState, appliesNewContacts, applyInfos, cardType, user]);
    var getItemVal = React.useCallback(function (key) {
        if (!user) {
            return '';
        }
        var item = user.fields.find(function (item) { return item.key === key; });
        return (item || {}).val || '';
    }, [user]);
    var avatar = React.useMemo(function () {
        if (cardType === UserCardType.Group) {
            return (group || {}).avatar || '';
        }
        // if (cardType === UserCardType.User) {
        if (!user) {
            return null;
        }
        // return user.fields.find((item) => item.key === 'avatar').val || '';
        return getItemVal('avatar');
        // }
        // return '';
    }, [group, cardType, getItemVal, user]);
    var name = React.useMemo(function () {
        if (cardType === UserCardType.Group) {
            return (group || {}).name || '';
        }
        if (!user) {
            return null;
        }
        return getItemVal('name');
    }, [group, cardType, getItemVal, user]);
    var avatarNode = React.useMemo(function () {
        if (!user) {
            return '';
        }
        return (React.createElement("div", { className: "user-card-avatar", style: {
                backgroundImage: "url(" + Infobg + ")",
                backgroundPosition: 'right bottom',
            } },
            React.createElement("div", { className: "user-card-avatar-item" },
                React.createElement("div", { className: "item-avatar" },
                    React.createElement(Avatar, { styleObj: {
                            width: 56,
                            height: 56,
                            fontSize: 20,
                            cursor: avatar ? 'pointer' : 'auto',
                        }, tag: user.accountType === 1 ? '公共账号' : '', src: getHeadImgThumbUrl(avatar, 150, 150), name: name, onClick: debounce(function () {
                            if (avatar && onClickAvatar) {
                                onClickAvatar(user);
                            }
                        }, 500) })),
                React.createElement("div", { className: "item-content" },
                    React.createElement("h4", { className: "name-wrap" },
                        React.createElement("div", { className: "item-content-name" }, name),
                        React.createElement("div", { className: "special-tag" }, (user === null || user === void 0 ? void 0 : user.labelInfoList) && tagsNode(user === null || user === void 0 ? void 0 : user.labelInfoList)),
                        emplFollow && (React.createElement(Tooltip, { placement: "bottom", title: "\u7279\u522B\u5173\u6CE8" },
                            React.createElement("span", { style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                } },
                                React.createElement(IconFont, { style: {
                                        marginLeft: '10px',
                                        color: '#FFC851',
                                    }, type: "icona-ic_pc_Star" })))))))));
    }, [avatar, emplFollow, buttons, name, onClickAvatar, user]);
    var nameSigNode = React.useMemo(function () {
        return null;
    }, []);
    React.useEffect(function () {
        if (isNull(user)) {
            return;
        }
        if (user) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultValidationMsg = "\u6211\u662F" + ((currentEmployee === null || currentEmployee === void 0 ? void 0 : currentEmployee.unitName) ? "\u201C" + (currentEmployee === null || currentEmployee === void 0 ? void 0 : currentEmployee.unitName) + "\u201D\u7684" : '') + currentEmployee.name;
            setValidationMsg(defaultValidationMsg);
            setCount(defaultValidationMsg.length);
        }
        else {
            setValidationMsg('');
            setCount(0);
        }
    }, [user, currentEmployee, cardType]);
    var actionOperate = React.useCallback(function (action) {
        switch (action) {
            case UserCardAction.Add:
                setActionState(UserCardAction.Send);
                break;
            case UserCardAction.JoinGroup:
                if (onActionClick) {
                    onActionClick({ type: UserCardAction.JoinGroup, data: data }).then(function (result) {
                        if (result) {
                            setActionState(UserCardAction.SendApplyGroup);
                        }
                    });
                }
                break;
            case UserCardAction.AddGroup:
                setActionState(UserCardAction.SendApplyGroup);
                break;
            case UserCardAction.SendApplyGroup:
                // 发送加群申请
                if (data) {
                    data.group.validationMsg = validationMsg;
                }
                if (onActionClick) {
                    onActionClick({ type: UserCardAction.AddGroup, data: data }).then(function (_a) {
                        var result = _a.data;
                        if (isError(result)) {
                            setActionState(UserCardAction.More_Times_Group);
                            return;
                        }
                        if (result) {
                            setActionState(UserCardAction.AppliedGroup);
                        }
                    });
                }
                break;
            case UserCardAction.Send:
                // 发送加人申请
                if (user && onActionClick) {
                    if (!validationMsg)
                        return message.error('验证信息不能为空');
                    if (defaultValidationMsg !== validationMsg) {
                        analysisLog === null || analysisLog === void 0 ? void 0 : analysisLog('xtbg_add_home_1637657110163', '80');
                    }
                    if (defaultRemark !== remark) {
                        analysisLog === null || analysisLog === void 0 ? void 0 : analysisLog('xtbg_add_home_1637657110163', '97');
                    }
                    user.validationMsg = validationMsg;
                    onActionClick({
                        type: UserCardAction.Send,
                        data: __assign(__assign({}, user), { remark: remark }),
                        accessPhone: checkedIphone ? '1' : '0',
                    }).then(function (_a) {
                        var result = _a.data;
                        if (result === 'more-times') {
                            setActionState(UserCardAction.More_Times);
                            return;
                        }
                        if (result) {
                            setActionState(UserCardAction.Applied);
                            setTimeout(function () {
                                hideUserCardModal();
                                // Bus.emit('app:toggle-user-card-modal:hide');
                            }, 1000);
                        }
                    });
                }
                break;
            case UserCardAction.Accept:
                if (user && onActionClick) {
                    onActionClick({
                        type: UserCardAction.Accept,
                        data: __assign(__assign({}, user), { remark: remark }),
                        accessPhone: checkedIphone ? '1' : '0',
                    }).then(function (_a) {
                        var result = _a.data;
                        if (result) {
                            setActionState(UserCardAction.Chat);
                            setTimeout(function () {
                                hideUserCardModal();
                            }, 1000);
                        }
                    });
                }
                break;
            case UserCardAction.Deleted:
                if (user && onActionClick) {
                    onActionClick({ type: UserCardAction.Deleted, data: user }).then();
                }
                break;
            default:
                break;
        }
    }, [
        checkedIphone,
        data,
        analysisLog,
        defaultRemark,
        hideUserCardModal,
        remark,
        defaultValidationMsg,
        onActionClick,
        user,
        validationMsg,
    ]);
    var actionButtonNode = React.useMemo(function () {
        var _a;
        if (!actionState || !user) {
            return null;
        }
        var classes = classNames({
            'action-btn-node': true,
            'add-group': [
                UserCardAction.AppliedGroup,
                UserCardAction.AddGroup,
                UserCardAction.JoinGroup,
                UserCardAction.More_Times_Group,
            ].includes(actionState),
            send: [UserCardAction.Send, UserCardAction.SendApplyGroup].includes(actionState),
            accept: actionState === UserCardAction.Accept,
            add: [UserCardAction.Applied, UserCardAction.Add, UserCardAction.More_Times].includes(actionState),
            deleted: actionState === UserCardAction.Deleted,
        });
        var btnTextConfig = (_a = {},
            _a[UserCardAction.Add] = '添加联系人',
            _a[UserCardAction.AddGroup] = '申请加群',
            _a[UserCardAction.JoinGroup] = '加入群',
            _a[UserCardAction.SendApplyGroup] = '发送申请',
            _a[UserCardAction.AppliedGroup] = '已申请',
            _a[UserCardAction.More_Times_Group] = '发送申请',
            _a[UserCardAction.Applied] = '已申请',
            _a[UserCardAction.Send] = '发送申请',
            _a[UserCardAction.More_Times] = '发送申请',
            _a[UserCardAction.Accept] = '通过验证',
            _a[UserCardAction.Expired] = '已过期',
            _a[UserCardAction.Deleted] = '删除联系人',
            _a[UserCardAction.Sended] = '已发送',
            _a);
        var disabled = [
            UserCardAction.Applied,
            UserCardAction.More_Times,
            UserCardAction.AppliedGroup,
            UserCardAction.More_Times_Group,
            UserCardAction.Expired,
            UserCardAction.Sended,
        ].includes(actionState);
        var showTip = [UserCardAction.More_Times].includes(actionState);
        var clstag = function (type) {
            switch (type) {
                case UserCardAction.Send:
                    return {
                        clstag: 'pageclick|keycount|xtbg_add_home_1637657110163|41',
                    };
                case UserCardAction.Add:
                    return {
                        clstag: 'pageclick|keycount|xtbg_add_home_1637657110163|25',
                    };
                case UserCardAction.Accept:
                    return {
                        clstag: 'pageclick|keycount|xtbg_add_home_1637657110163|42',
                    };
                case UserCardAction.Deleted:
                    return {
                        clstag: 'pageclick|keycount|xtbg_add_home_1637657110163|18',
                    };
                default:
                    return { clstag: '' };
            }
        };
        return (React.createElement("div", { className: classes },
            React.createElement(Button, __assign({ type: "primary", onClick: actionOperate.bind(null, actionState), disabled: disabled }, clstag(actionState)), btnTextConfig[actionState])));
    }, [actionOperate, actionState, user]);
    var errorNode = React.useMemo(function () {
        return (React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '40vh',
                padding: 20,
            } },
            React.createElement("h4", null,
                React.createElement("span", null, error))));
    }, [error]);
    var triggerEmplFollow = useCallback(function (e) { return __awaiter(_this, void 0, void 0, function () {
        var _a, result, err;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!user) {
                        return [2 /*return*/];
                    }
                    setEmplFollowLoading(true);
                    return [4 /*yield*/, setEmplFollow({
                            userIds: [
                                {
                                    userId: (user === null || user === void 0 ? void 0 : user.userId) || '',
                                    appId: (user === null || user === void 0 ? void 0 : user.appId) || '',
                                    teamId: (user === null || user === void 0 ? void 0 : user.teamId) || '',
                                },
                            ],
                            type: e ? 1 : 0,
                        })];
                case 1:
                    _a = _b.sent(), result = _a[0], err = _a[1];
                    setEmplFollowLoading(false);
                    if (err) {
                        message.error((err === null || err === void 0 ? void 0 : err.message) || '设置失败');
                        return [2 /*return*/];
                    }
                    message.success("\u8BBE\u7F6E\u6210\u529F");
                    setUser(__assign(__assign({}, user), { isFollow: !emplFollow ? 1 : 0 }));
                    setEmplFollowState(e);
                    setSwitchLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [emplFollow, setEmplFollow, user]);
    var triggerEmplFollowList = useCallback(function () {
        triggerEvent === null || triggerEvent === void 0 ? void 0 : triggerEvent('showEmplFollowList');
        hideUserCardModal();
    }, [triggerEvent, hideUserCardModal]);
    var emplFollowNode = useMemo(function () {
        if (isRobot) {
            return null;
        }
        return (React.createElement("div", { className: "me-user-card-item V2" },
            React.createElement("div", { className: "Verification-setting" },
                React.createElement("h5", { className: "usercard-item-title" }, "\u7279\u522B\u5173\u6CE8"),
                React.createElement(Switch, { style: {
                        marginTop: '7px',
                    }, size: "small", loading: emplFollowLoading, checked: emplFollow, onChange: triggerEmplFollow })),
            React.createElement("div", { style: {
                    color: '#666666',
                    paddingTop: '10px',
                } },
                "\u5355\u804A\u3001\u7FA4\u804A\u4E2D\u7684\u6D88\u606F\u7279\u522B\u63D0\u793A\uFF0C\u5E76\u4E14\u4E0D\u53D7\u514D\u6253\u6270\u5F71\u54CD\u3002\u67E5\u770B\u6211\u7684",
                React.createElement("span", { style: {
                        cursor: 'pointer',
                    }, className: "primary", onClick: triggerEmplFollowList }, "\u7279\u522B\u5173\u6CE8"))));
    }, [emplFollow, emplFollowLoading, triggerEmplFollow, triggerEmplFollowList, isRobot]);
    var publicNode = useMemo(function () {
        if (!((user === null || user === void 0 ? void 0 : user.publicEmplManagerUserId) && (user === null || user === void 0 ? void 0 : user.publicEmplManagerName))) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Line, null),
            React.createElement("div", { className: "me-user-card-item V2" },
                React.createElement("div", { className: "usercard-item-content" },
                    React.createElement("h5", { className: "usercard-item-title inner" }, "\u8D23\u4EFB\u4EBA"),
                    React.createElement("p", { className: "usercard-item-desc", style: {
                            display: 'flex',
                            alignItems: 'center',
                        } },
                        user.publicEmplManagerName,
                        "\u00A0\u00A0\u00A0\u00A0",
                        React.createElement("span", { onClick: function () {
                                triggerEvent === null || triggerEvent === void 0 ? void 0 : triggerEvent('showPublicEmplManagerCard', {
                                    userId: user.publicEmplManagerUserId,
                                });
                            }, style: {
                                marginTop: '-3px',
                                cursor: 'pointer',
                                color: '#ACC5F1',
                            } },
                            React.createElement(IconFont, { type: "iconic_app_businesscard" })))),
                React.createElement("div", { className: "usercard-item-content" },
                    React.createElement("h5", { className: "usercard-item-title inner" }, "\u4F7F\u7528\u4EBA"),
                    React.createElement("p", { className: "usercard-item-desc " + (user.publicEmplUsageUserId ? '' : 'disabled'), style: {
                            display: 'flex',
                            alignItems: 'center',
                            color: user.publicEmplUsageUserId ? '#232930' : '#999',
                        } },
                        user.publicEmplUsageName || '无人使用',
                        "\u00A0\u00A0\u00A0\u00A0",
                        React.createElement("span", { onClick: function () {
                                triggerEvent === null || triggerEvent === void 0 ? void 0 : triggerEvent('showPublicEmplUsageCard', {
                                    userId: user.publicEmplUsageUserId,
                                });
                            }, style: {
                                marginTop: '-3px',
                                cursor: user.publicEmplUsageUserId ? 'pointer' : 'no-drop',
                                color: user.publicEmplUsageUserId ? '#ACC5F1' : '#999',
                            } },
                            React.createElement(IconFont, { type: "iconic_app_businesscard" })))))));
    }, [triggerEvent, user]);
    var handleCheckedIphoneChange = React.useCallback(function (clstag) { return __awaiter(_this, void 0, void 0, function () {
        var fields_1, _a, result, err;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!user) {
                        return [2 /*return*/];
                    }
                    analysisLog === null || analysisLog === void 0 ? void 0 : analysisLog('xtbg_add_home_1637657110163', clstag);
                    setSwitchLoading(true);
                    if (!(actionState === UserCardAction.Deleted)) return [3 /*break*/, 2];
                    fields_1 = {};
                    ((user === null || user === void 0 ? void 0 : user.fields) || []).forEach(function (fieldItem) {
                        fields_1[fieldItem.key] = fieldItem.val;
                    });
                    return [4 /*yield*/, setModifyFriend({
                            pin: (user === null || user === void 0 ? void 0 : user.userId) || '',
                            app: (user === null || user === void 0 ? void 0 : user.appId) || '',
                            teamId: (user === null || user === void 0 ? void 0 : user.teamId) || '',
                            accessPhone: !checkedIphone ? '1' : '0',
                            nickName: fields_1['name'] || '',
                            acrossApp: user.userType
                                ? user.userType === '5'
                                : (user === null || user === void 0 ? void 0 : user.appId) !== currentEmployee.appId,
                        })];
                case 1:
                    _a = _b.sent(), result = _a[0], err = _a[1];
                    if (err) {
                        message.error((err === null || err === void 0 ? void 0 : err.message) || '设置失败');
                        setSwitchLoading(false);
                        return [2 /*return*/];
                    }
                    message.success("\u8BBE\u7F6E\u6210\u529F");
                    setUser(__assign(__assign({}, user), { accessPhone: !checkedIphone ? 1 : 0 }));
                    _b.label = 2;
                case 2:
                    setCheckedIphone(!checkedIphone);
                    setSwitchLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [actionState, analysisLog, checkedIphone, currentEmployee.appId, setModifyFriend, user]);
    // 设置手机号可见性
    var verificationSetting = React.useCallback(function (_a) {
        var clstag = _a.clstag;
        if (!user) {
            return null;
        }
        return (React.createElement("div", { className: "Verification-setting" },
            React.createElement("span", null, "\u5141\u8BB8\u5BF9\u65B9\u67E5\u770B\u6211\u7684\u624B\u673A\u53F7"),
            React.createElement(Switch, { loading: switchLoading, checked: checkedIphone, onChange: function () {
                    handleCheckedIphoneChange(clstag);
                } })));
    }, [user, switchLoading, checkedIphone, handleCheckedIphoneChange]);
    var levelNode = React.useMemo(function () {
        return (userLevelData === null || userLevelData === void 0 ? void 0 : userLevelData.fileUrl) ? (React.createElement("img", { className: "user-card-level-avatar", style: {
                width: 70,
                height: 20,
                backgroundColor: 'transparent',
                borderRadius: 0,
            }, src: userLevelData.fileUrl, onClick: function () { return openUserLevelDetail === null || openUserLevelDetail === void 0 ? void 0 : openUserLevelDetail(userLevelData.ext); } })) : null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userLevelData]);
    var actionNode = React.useMemo(function () {
        if (cardType === UserCardType.Web || !user || !buttons) {
            return null;
        }
        return (
        // <div className="me-user-card-actions">{actionsExtra}</div>
        React.createElement("div", { className: "me-user-card-actions" },
            buttons.chat && (React.createElement(Tooltip, { placement: "bottom", title: "\u6D88\u606F" },
                React.createElement(Button
                // type="primary"
                , { 
                    // type="primary"
                    shape: "circle", size: "large", icon: React.createElement(IconFont, { type: "iconic_chat", style: { color: colors.primary2 } }), onClick: function () {
                        if (onActionClick) {
                            if (analysisLog) {
                                if (isMessageModule) {
                                    analysisLog('Xtbg_Msg_Dialog|InitiateSession');
                                }
                                else {
                                    analysisLog('xtbg_add_home_1637657110163', '19');
                                }
                            }
                            onActionClick({ type: UserCardAction.Chat, data: user });
                        }
                    } }))),
            buttons.voip &&
                currentEmployee.app === (user === null || user === void 0 ? void 0 : user.appId) &&
                !getIsSelf(currentEmployee, user) &&
                isfriend === 1 && (React.createElement(Tooltip, { placement: "bottom", title: "\u8BED\u97F3" },
                React.createElement(Button
                // type="primary"
                , { 
                    // type="primary"
                    shape: "circle", size: "large", style: { marginLeft: '8px' }, icon: React.createElement(IconFont, { type: "iconapp_btn_joymerting_answer", style: { color: colors.primary2 } }), onClick: function () {
                        if (onActionClick) {
                            if (analysisLog) {
                                if (isMessageModule) {
                                    analysisLog('Xtbg_Msg_Dialog|InitiateVoip');
                                }
                                else {
                                    analysisLog('xtbg_add_home_1637657110163', '20');
                                }
                            }
                            onActionClick({ type: UserCardAction.Voip, data: user });
                        }
                    } }))),
            buttons.video && !getIsSelf(currentEmployee, user) && isfriend === 1 && (React.createElement(Tooltip, { placement: "bottom", title: "\u89C6\u9891" },
                React.createElement(Button
                // type="primary"
                , { 
                    // type="primary"
                    shape: "circle", size: "large", style: { marginLeft: '8px' }, icon: React.createElement(IconFont, { type: "iconapp_btn_joymerting_video", style: { color: colors.primary2 } }), onClick: function () {
                        if (onActionClick) {
                            if (analysisLog) {
                                if (isMessageModule) {
                                    analysisLog('Xtbg_Msg_Dialog|InitiateMeeting');
                                }
                                else {
                                    analysisLog('xtbg_add_home_1637657110163', '21');
                                }
                            }
                            if (isExternsContactsVideo) {
                                onActionClick({ type: UserCardAction.Jrtc, data: user });
                            }
                            else {
                                onActionClick({ type: UserCardAction.Meeting, data: user });
                            }
                        }
                    } }))),
            buttons.webVideo && !getIsSelf(currentEmployee, user) && isfriend === 1 && (React.createElement(Tooltip, { placement: "bottom", title: "\u89C6\u9891" },
                React.createElement(Button
                // type="primary"
                , { 
                    // type="primary"
                    shape: "circle", size: "large", style: { marginLeft: '8px' }, icon: React.createElement(IconFont, { type: "iconapp_btn_joymerting_video", style: { color: colors.primary2 } }), onClick: function () {
                        if (onActionClick) {
                            if (analysisLog) {
                                if (isMessageModule) {
                                    analysisLog('Xtbg_Msg_Dialog|InitiateMeeting');
                                }
                                else {
                                    analysisLog('xtbg_add_home_1637657110163', '21');
                                }
                            }
                            onActionClick({ type: UserCardAction.Jrtc, data: user });
                        }
                    } }))),
            buttons.share && (getIsSelf(currentEmployee, user) || isfriend === 1) && (React.createElement(Tooltip, { placement: "bottom", title: "\u5206\u4EAB" },
                React.createElement(Button
                // type="primary"
                , { 
                    // type="primary"
                    shape: "circle", size: "large", style: { marginLeft: '8px' }, icon: React.createElement(IconFont, { type: "iconfenxiang", style: { color: colors.primary2 } }), onClick: function () {
                        if (onActionClick) {
                            if (analysisLog) {
                                if (isMessageModule) {
                                    analysisLog('Xtbg_Msg_Dialog|ShareUserCard');
                                }
                                else {
                                    analysisLog('xtbg_add_home_1637657110163', '22');
                                }
                            }
                            onActionClick({ type: UserCardAction.Share, data: user });
                        }
                    } }))),
            buttons.add &&
                canAddContact !== false &&
                currentEmployee.app === (user === null || user === void 0 ? void 0 : user.appId) &&
                !getIsSelf(currentEmployee, user) && (React.createElement(Tooltip, { placement: "bottom", title: "\u6DFB\u52A0\u8054\u7CFB\u4EBA" },
                React.createElement(Button
                // type="primary"
                , { 
                    // type="primary"
                    shape: "circle", size: "large", style: { marginLeft: '8px' }, icon: React.createElement(IconFont, { type: "icontianjialianxiren", style: { color: colors.primary2 } }), onClick: function () {
                        if (analysisLog) {
                            if (isMessageModule) {
                                analysisLog('Xtbg_Msg_Dialog|AddFriend');
                            }
                            else {
                                analysisLog('xtbg_add_home_1637657110163', '23');
                            }
                        }
                        setActionState(UserCardAction.Send);
                    } })))));
    }, [
        cardType,
        user,
        canAddContact,
        buttons,
        currentEmployee,
        isfriend,
        onActionClick,
        analysisLog,
        isMessageModule,
        isExternsContactsVideo,
    ]);
    var replyTextAreaChange = function (event) {
        var inputValue = (event.target.value || '').trim();
        if (inputValue.length > 50) {
            return false;
        }
        setReplyMsg(inputValue);
        setReplyCount(inputValue.length);
    };
    // 验证消息
    var validationInfoNode = React.useMemo(function () {
        if (!loadApplyInfos || !loadApplyInfos.length) {
            return null;
        }
        var isShowReply = actionState === UserCardAction.Accept ? true : isCanReply === 1 ? true : false;
        return (React.createElement(React.Fragment, null,
            React.createElement(Line, null),
            React.createElement("div", { className: "validation-info-node" },
                React.createElement("div", { className: "title" }, "\u9A8C\u8BC1\u4FE1\u606F"),
                React.createElement("div", { className: "info" },
                    loadApplyInfos.map(function (info, index) {
                        return (React.createElement("div", { key: index, className: "info-item" },
                            info.name || info.realName || '我',
                            ": ",
                            info.info));
                    }),
                    !replyIsShow && isShowReply && (React.createElement("span", { style: { color: colors.primary2, cursor: 'pointer' }, onClick: function () {
                            setReplyIsShow(true);
                            analysisLog === null || analysisLog === void 0 ? void 0 : analysisLog('xtbg_add_home_1637657110163', '81');
                        } }, "\u56DE\u590D")),
                    replyIsShow && (React.createElement("div", { className: "validation-info-message" },
                        React.createElement(TextArea, { defaultValue: replyMsg, value: replyMsg, onChange: replyTextAreaChange }),
                        React.createElement("div", { className: "validation-info-length" },
                            React.createElement("span", null, replyCount),
                            " /50"),
                        React.createElement("div", { className: "validation-info-confirm" },
                            React.createElement(Button, { type: "primary", size: "small", disabled: !replyMsg, onClick: function () {
                                    onActionClick({
                                        type: UserCardAction.Reply,
                                        data: user,
                                        replyMsg: replyMsg,
                                        applyId: applyId,
                                        flag: flag,
                                        reply: reply,
                                    }).then(function (_a) {
                                        var result = _a.data;
                                        if (result) {
                                            setReplyIsShow(false);
                                            setReplyMsg('');
                                            setReplyCount(0);
                                            setLoadApplyInfos(__spreadArrays(loadApplyInfos, [
                                                {
                                                    userId: currentEmployee.userId,
                                                    appId: currentEmployee.app,
                                                    teamId: currentEmployee.teamId,
                                                    info: replyMsg,
                                                },
                                            ]).slice(-3));
                                        }
                                    });
                                } }, "\u53D1\u9001"))))))));
    }, [
        actionState,
        analysisLog,
        applyId,
        currentEmployee.app,
        currentEmployee.teamId,
        currentEmployee.userId,
        flag,
        isCanReply,
        loadApplyInfos,
        onActionClick,
        reply,
        replyCount,
        replyIsShow,
        replyMsg,
        user,
    ]);
    // 可以发起会话的卡片显示内容
    var getNoActionNode = React.useCallback(function () {
        if (user) {
            return (React.createElement("div", null,
                avatarNode,
                React.createElement("div", { className: "user-item-container" }, nameSigNode)));
        }
    }, [user, avatarNode, nameSigNode]);
    // 右上角更多 （删除）
    var getDeleteSettingNode = React.useCallback(function () {
        if (user &&
            cardType === UserCardType.User &&
            contactRelationship &&
            contactRelationship.friendship) {
            return (React.createElement("div", { className: "container" },
                React.createElement("div", { className: "validation-msg-node", style: { height: 'auto' } },
                    React.createElement("p", { className: "validation-title delete-setting" },
                        React.createElement("span", { className: "anticon", onClick: function () {
                                setActionState(prevActionState.current || UserCardAction.Chat);
                            } },
                            React.createElement(IconFont, { type: "iconwin_left" })),
                        "\u8D44\u6599\u8BBE\u7F6E"),
                    contactRelationship.friendship !== 8 && (React.createElement("div", { className: "Verification-info", style: {
                            marginBottom: '50px',
                        } },
                        React.createElement("p", { className: "Verification-info-title" }, "\u9690\u79C1\u8BBE\u7F6E"),
                        verificationSetting({
                            clstag: '48',
                        })))),
                React.createElement("div", null, contactRelationship.isRemove && actionButtonNode)));
        }
    }, [user, cardType, contactRelationship, verificationSetting, actionButtonNode]);
    // 可以发起会话的卡片显示内容
    var getChatActionNode = React.useCallback(function () {
        if (user) {
            return (React.createElement("div", { className: "usercard-wrap" },
                contactRelationship.isRemove && cardType === UserCardType.User && (React.createElement("div", { className: "more-operations-node" },
                    React.createElement(IconFont, { type: "iconapp_btn_joymerting_more", onClick: function () {
                            prevActionState.current = actionState;
                            setActionState(UserCardAction.Deleted);
                            setCheckedIphone(user.accessPhone ? true : false);
                            // setEmplFollowState(user.isFollow ? true : false);
                        } }))),
                React.createElement("div", { className: "user-card-head-wrap" },
                    avatarNode,
                    levelNode,
                    actionNode),
                React.createElement("div", { className: "user-item-container" },
                    nameSigNode,
                    publicNode,
                    React.createElement(UserInfoItem, { user: user, notPersonalCalendar: notPersonalCalendar, onActionClick: onActionClick, triggerEvent: triggerEvent, cardType: cardType, remarkSet: handleRemarkSet, showTag: !!onSetTagForEmpl, handleAddTag: handleAddTag, analysisLog: analysisLog, currentUser: currentEmployee, examineMobileRecord: examineMobileRecord, webExamineMobileRecord: webExamineMobileRecord }),
                    (actions === null || actions === void 0 ? void 0 : actions[0]) === UserCardAction.Expired && validationInfoNode,
                    !isRobot && React.createElement(Line, null),
                    emplFollowNode,
                    getIsSelf(currentEmployee, user) &&
                        ![UserCardType.Web, UserCardType.CustomUser].includes(cardType) && (React.createElement(React.Fragment, null,
                        React.createElement(Line, null),
                        React.createElement("div", { style: { margin: '20px 19px' } },
                            "\u5982\u6709\u95EE\u9898\u8BF7\u8054\u7CFB",
                            isExternsContacts && (React.createElement(React.Fragment, null,
                                React.createElement("span", { style: {
                                        color: "" + colors.primary2,
                                        cursor: 'pointer',
                                    }, onClick: function () {
                                        onActionClick({
                                            type: UserCardAction.Administrator,
                                            data: user,
                                        });
                                    } }, "\u7BA1\u7406\u8005"),
                                "\u6216")),
                            React.createElement("span", { style: {
                                    color: "" + colors.primary2,
                                    cursor: 'pointer',
                                }, onClick: function () {
                                    onActionClick({
                                        type: UserCardAction.UnitAdministrator,
                                        data: user,
                                    });
                                } }, "\u5355\u4F4D\u7BA1\u7406\u5458")))))));
        }
    }, [
        user,
        triggerEvent,
        notPersonalCalendar,
        contactRelationship,
        cardType,
        avatarNode,
        levelNode,
        actionNode,
        nameSigNode,
        publicNode,
        handleRemarkSet,
        handleAddTag,
        analysisLog,
        currentEmployee,
        examineMobileRecord,
        webExamineMobileRecord,
        actions,
        validationInfoNode,
        emplFollowNode,
        isExternsContacts,
        actionState,
        onActionClick,
    ]);
    var getGroupOwnerItemNode = React.useMemo(function () {
        if (cardType !== UserCardType.Group) {
            return null;
        }
        var _a = group.owner || {}, avatar = _a.avatar, name = _a.name;
        return (React.createElement("div", { className: "card-group-owner" },
            React.createElement(Avatar, { src: getHeadImgThumbUrl(avatar, 150, 150), name: name }),
            React.createElement("div", { className: "card-group-owner-name" },
                "\u7FA4\u521B\u5EFA\u4EBA\uFF1A ",
                name)));
    }, [cardType, group]);
    // 添加联系人
    var getAddContactNode = React.useMemo(function () {
        var _a;
        if (!((_a = user === null || user === void 0 ? void 0 : user.partTimeTitleDeptInfo) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        return (React.createElement("div", { className: "me-user-card-item V2" },
            React.createElement(UserDeptTitle, { partTimeTitleDeptInfo: user.partTimeTitleDeptInfo, status: UserCardAction.Add }),
            React.createElement(Remark, { user: user, cardType: cardType, currentUser: currentEmployee, analysisLog: analysisLog, remarkSet: handleRemarkSet })));
    }, [analysisLog, cardType, currentEmployee, handleRemarkSet, user]);
    var handleRemarkChange = useCallback(function (event) {
        var inputValue = event.target.value;
        setRemark(inputValue.trim() || '');
    }, []);
    // 仅可通过扫码方式添加
    var onlyScanAddNode = React.useMemo(function () {
        if (!user) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Line, null),
            React.createElement("div", { className: "only-scan-add" },
                React.createElement(IconFont, { type: "iconic_describe1", className: "iconic_describe1" }),
                "\u4EC5\u53EF\u901A\u8FC7\u626B\u7801\u65B9\u5F0F\u6DFB\u52A0")));
    }, [user]);
    // 添加好友
    var getAddActionNode = React.useCallback(function () {
        if (!contactRelationship || !user) {
            return null;
        }
        if (canAddContact === false) {
            return React.createElement("div", { className: "container" },
                React.createElement("div", { className: "user-card-head-wrap" }, avatarNode));
        }
        return (React.createElement("div", { className: "container" },
            React.createElement("div", { className: "user-card-head-wrap" }, avatarNode),
            React.createElement("div", { className: "user-item-container" },
                nameSigNode,
                publicNode,
                React.createElement(Line, null),
                getAddContactNode,
                React.createElement(Line, null),
                emplFollowNode),
            contactRelationship.isOnlyScanAdd ? onlyScanAddNode : actionButtonNode));
    }, [
        contactRelationship,
        user,
        canAddContact,
        emplFollowNode,
        avatarNode,
        nameSigNode,
        publicNode,
        getAddContactNode,
        onlyScanAddNode,
        actionButtonNode,
    ]);
    // 新的申请过期
    var getExpiredActionNode = React.useCallback(function () {
        if (isfriend) {
            setActionState(UserCardAction.Chat);
            return;
        }
        return (React.createElement("div", { className: "container" },
            avatarNode,
            React.createElement("div", { className: "user-item-container" },
                nameSigNode,
                React.createElement(Line, null),
                getAddContactNode,
                validationInfoNode),
            actionButtonNode));
    }, [
        isfriend,
        avatarNode,
        nameSigNode,
        getAddContactNode,
        validationInfoNode,
        actionButtonNode,
    ]);
    var getJoinActionNode = React.useCallback(function () {
        return (React.createElement("div", { className: "container" },
            avatarNode,
            React.createElement("div", { className: "user-item-container" },
                nameSigNode,
                React.createElement(Line, null),
                getGroupOwnerItemNode),
            actionButtonNode));
    }, [avatarNode, getGroupOwnerItemNode, nameSigNode, actionButtonNode]);
    // 通过验证
    var getAcceptActionNode = React.useCallback(function () {
        if (!user) {
            return null;
        }
        return (React.createElement("div", { className: "container" },
            avatarNode,
            React.createElement("div", { className: "user-item-container" },
                nameSigNode,
                React.createElement(Line, null),
                getAddContactNode,
                validationInfoNode,
                React.createElement(Line, null),
                React.createElement("div", { style: { margin: '14px 20px 0' } }, verificationSetting({
                    clstag: '49',
                }))),
            actionButtonNode));
    }, [
        user,
        avatarNode,
        nameSigNode,
        getAddContactNode,
        validationInfoNode,
        verificationSetting,
        actionButtonNode,
    ]);
    // 已发送
    var getSendedActionNode = React.useCallback(function () {
        if (!user) {
            return null;
        }
        return (React.createElement("div", { className: "container" },
            avatarNode,
            React.createElement("div", { className: "user-item-container" },
                nameSigNode,
                React.createElement(Line, null),
                getAddContactNode,
                React.createElement(Line, null),
                validationInfoNode,
                React.createElement(Line, null),
                React.createElement("div", { style: { margin: '14px 20px 0' } }, verificationSetting({}))),
            actionButtonNode));
    }, [
        user,
        avatarNode,
        nameSigNode,
        getAddContactNode,
        validationInfoNode,
        verificationSetting,
        actionButtonNode,
    ]);
    var textAreaChange = function (event) {
        var inputValue = event.target.value;
        if (inputValue.length > 50) {
            return false;
        }
        setValidationMsg(inputValue.trim());
        setCount(inputValue.length);
    };
    // 验证消息节点
    var validationMsgNode = React.useMemo(function () {
        if (!name || !user) {
            return null;
        }
        return (React.createElement("div", { className: "validation-msg-node" },
            React.createElement("p", { className: "validation-title" },
                "\u7533\u8BF7\u6DFB\u52A0\u8054\u7CFB\u4EBA",
                cardType === UserCardType.User && (React.createElement("span", { className: "anticon", onClick: function () {
                        hideUserCardModal();
                        // Bus.emit('app:toggle-user-card-modal:hide');
                    } },
                    React.createElement("img", { src: closeIcon, alt: "" })))),
            React.createElement("div", { className: "Verification-info" },
                React.createElement("p", { className: "Verification-info-title" }, "\u9A8C\u8BC1\u4FE1\u606F"),
                React.createElement("div", { className: "validation-info-message" },
                    React.createElement(TextArea, { className: "message", defaultValue: validationMsg, value: validationMsg, 
                        // maxLength={50}
                        onChange: textAreaChange }),
                    React.createElement("div", { className: "validation-info-length" },
                        React.createElement("span", null, count),
                        " /50")),
                React.createElement("p", { className: "Verification-info-title" }, "\u8BBE\u7F6E\u5907\u6CE8"),
                React.createElement("div", { className: "validation-info-message" },
                    React.createElement(TextArea, { className: "message", defaultValue: remark, value: remark, placeholder: "\u8BBE\u7F6E\u5907\u6CE8", maxLength: 20, onChange: handleRemarkChange }),
                    React.createElement("div", { className: "validation-info-length" },
                        React.createElement("span", null, remark.length),
                        " /20")),
                React.createElement("p", { className: "Verification-info-title" }, "\u9690\u79C1\u8BBE\u7F6E"),
                verificationSetting({
                    clstag: '50',
                }))));
    }, [
        cardType,
        count,
        handleRemarkChange,
        hideUserCardModal,
        name,
        remark,
        user,
        validationMsg,
        verificationSetting,
    ]);
    var getSendActionNode = React.useCallback(function () {
        return (React.createElement("div", { className: "container" },
            validationMsgNode,
            actionButtonNode));
    }, [actionButtonNode, validationMsgNode]);
    var getChatTagNode = useCallback(function () {
        return (React.createElement(TagNode, { onSaveUserTag: onSaveUserTag, goBack: resetPrevAction, onGetTagList: onGetTagList, onSetTag: onSetTag, user: user }));
    }, [onGetTagList, onSetTag, resetPrevAction, onSaveUserTag, user]);
    var getActionNode = React.useCallback(function () {
        var _a;
        if (cardType === UserCardType.User && !user) {
            return null;
        }
        else if (cardType === UserCardType.Group && !group) {
            return null;
        }
        // // 没有actions 支持打开会话 为了兼容老版本调用
        // if ((actions || []).length === 0 || actions.includes(UserCardAction.Chat)) {
        //     return getChatActionNode();
        // }
        var actionNodeMap = (_a = {},
            _a[UserCardAction.No] = getNoActionNode,
            _a[UserCardAction.Tag] = getChatTagNode,
            _a[UserCardAction.Chat] = getChatActionNode,
            _a[UserCardAction.Send] = getSendActionNode,
            _a[UserCardAction.SendApplyGroup] = getSendActionNode,
            _a[UserCardAction.Accept] = getAcceptActionNode,
            _a[UserCardAction.Applied] = getSendActionNode,
            _a[UserCardAction.Add] = getAddActionNode,
            _a[UserCardAction.More_Times] = getAddActionNode,
            _a[UserCardAction.AddGroup] = getAddActionNode,
            _a[UserCardAction.JoinGroup] = getJoinActionNode,
            _a[UserCardAction.AppliedGroup] = getAddActionNode,
            _a[UserCardAction.More_Times_Group] = getAddActionNode,
            _a[UserCardAction.Expired] = getExpiredActionNode,
            _a[UserCardAction.Deleted] = getDeleteSettingNode,
            _a[UserCardAction.Sended] = getSendedActionNode,
            _a);
        // if (isfriend === -1 && cardType !== UserCardType.Web) {
        //     return loadingNode;
        // }
        // @ts-ignore
        if (isFunction(actionNodeMap[actionState])) {
            // @ts-ignore
            return actionNodeMap[actionState]();
        }
    }, [
        cardType,
        user,
        group,
        getNoActionNode,
        getChatTagNode,
        getChatActionNode,
        getSendActionNode,
        getAcceptActionNode,
        getAddActionNode,
        getJoinActionNode,
        getExpiredActionNode,
        getDeleteSettingNode,
        getSendedActionNode,
        actionState,
    ]);
    var modalBody = React.useMemo(function () {
        // if (!visible) {
        //     return null;
        // }
        if (error) {
            return errorNode;
        }
        return getActionNode();
    }, [error, getActionNode, errorNode]);
    if (!modalBody) {
        return null;
    }
    return React.createElement("div", { className: "wrap" }, modalBody);
}
export default UserCard;
//# sourceMappingURL=index.js.map